// services/uploadService.ts
import axios from "axios";
import Globais, { validateToken } from "../components/Globais";

export const uploadFilesService = async (
  fileList: any[],
  cotaUsuarioId: number | undefined | null
) => {
  const Token = validateToken(); // Obtenção do token

  if (!Token) {
    // Se o token não for válido, retorna imediatamente para evitar fazer a requisição
    throw new Error("Token inválido. Usuário não autenticado.");
  }

  const URLArquivo = `${Globais.DOMINIOBACK}/arquivo/upload`;

  // Verificação para garantir que cotaUsuarioId seja válido (número ou string)
  const validCotaUsuarioId = cotaUsuarioId != null ? String(cotaUsuarioId) : "";

  const uploadPromises = fileList.map((f) => {
    const formData = new FormData();
    formData.append("file", f); // Aqui f deve ser um arquivo ou Blob
    formData.append("tipo", "1");
    formData.append("cotaUsuarioId", validCotaUsuarioId); // Garantimos que cotaUsuarioId seja uma string
    formData.append("origem", String(Token?.id));

    return axios.post(URLArquivo, formData, {
      headers: {
        Authorization: Token.AuthStr,
        "Content-Type": "multipart/form-data",
      },
    });
  });

  // Aguarda todas as promessas serem resolvidas antes de retornar
  return Promise.all(uploadPromises);
};
